import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { ProfileContactMethods } from "@/features/settings/components/profile-contact-methods"
import { ProfileDetails } from "@/features/settings/components/profile-details"
import { ProfileSecurity } from "@/features/settings/components/profile-security"
import { ProfileSessions } from "@/features/settings/components/profile-sessions"
import { PageContent } from "@/components/common/page-content"
import { profileQueries } from "@/queries/profile"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/profile/"
)({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(profileQueries.detail()),
      context.queryClient.ensureQueryData(profileQueries.sessions()),
    ]),
  component: ProfileSettingsPage,
})

function ProfileSettingsPage() {
  const { data: profile } = useSuspenseQuery(profileQueries.detail())

  return (
    <>
      <PageHeader title="My profile" />
      <PageContent>
        <ProfileDetails profile={profile} />
        <ProfileContactMethods profile={profile} />
        <ProfileSecurity />
        <ProfileSessions />
      </PageContent>
    </>
  )
}
